(() => {

  let default_price = "From $2000"
  const params = new URLSearchParams(window.location.search);
  const sale_price = document.querySelector(".product-container .price--on-sale");
  if(sale_price){
    sale_price.classList.remove("price--on-sale")
  }
  const variantId = params.get('variant');
  if (variantId) {
    const buttons = document.querySelectorAll(`.turnkey-installation-item__btn[data-variant-id="${variantId}"]`);
    if (buttons.length > 0) {
      buttons[0].classList.add('active');
      if(buttons[0].nextElementSibling){
        buttons[0].nextElementSibling.classList.add("active");
      }else{
        buttons[0].classList.add('init-active');
      }
      if(buttons[0].dataset.variantPrice){
        default_price = "$"+ (buttons[0].dataset.variantPrice/100.0).toFixed(2);
      }
    }
  }
  const priceEle = document.querySelector(".product-container .product__price>.price");
  window.turnkeyInstallationStateObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if(priceEle.querySelector('.price-item--regular') && priceEle.querySelector('.price-item--regular').innerText != default_price){
        priceEle.innerHTML= '<div class="price__pricing-group"><div class="price__regular"><span class="price-item price-item--regular" data-regular-price="">'+default_price+'</span></div></div>'
      }
    });
  });
  if(priceEle){
    window.turnkeyInstallationStateObserver.observe(priceEle, {
      childList: true,
      subtree: true
    });
    priceEle.innerHTML= '<div class="price__pricing-group"><div class="price__regular"><span class="price-item price-item--regular" data-regular-price="">'+default_price+'</span></div></div>'
  }
  const API_URL = 'https://api-a.ecoflow.com/website/installFee/shopify/calculate';
  const API_APP_ID = '51';

  function toCurrencyLikeValue(value) {
    if (value === null || value === undefined) return '';
    return String(value);
  }

  function createState(block) {
    const productForm = block.closest('form');
    const submitGroup = productForm
      ? productForm.querySelector('.product-form__controls-group--submit')
      : document.querySelector('.product-form__controls-group--submit');
    const submitButton = productForm
      ? productForm.querySelector('.product-form__cart-submit_wrap button[type="submit"]')
      : document.querySelector('.product-form__cart-submit_wrap button[type="submit"]');
    const priceWrapper = submitGroup ? submitGroup.querySelector('.price-wrapper') : null;
    const regularPrice = priceWrapper ? priceWrapper.querySelector('.regular-price') : null;
    const productPrice = priceEle ? priceEle : null;
    const comparePrice = priceWrapper ? priceWrapper.querySelector('.compare-price') : null;
    const totalSavings = priceWrapper ? priceWrapper.querySelector('.total-savings') : null;
    const formInput = block.querySelector('[data-installation-form-input]');
    const formSubmit = block.querySelector('[data-installation-form-submit]');
    const formError = block.querySelector('[data-installation-form-error]');
    const zipHidden = block.querySelector('#installation_zip_message');
    const feeHidden = block.querySelector('#installation_fee_message');
    const sevenDayNote = block.querySelector('[data-seven-day-note]');

    return {
      block,
      productForm,
      submitButton,
      priceWrapper,
      regularPrice,
      productPrice,
      comparePrice,
      totalSavings,
      formInput,
      formSubmit,
      formError,
      zipHidden,
      feeHidden,
      sevenDayNote,
      finalVariantId: '',
      finalVariantSku: '',
      isFeeReady: false,
      isRequesting: false,
      originalRegularPriceText: regularPrice ? regularPrice.textContent : '',
      originalComparePriceText: comparePrice ? comparePrice.textContent : '',
      originalTotalSavingsText: totalSavings ? totalSavings.textContent : ''
    };
  }

  function setError(state, message) {
    if (!state.formError) return;
    state.formError.textContent = message || '';
  }

  function getErrorText(state, key) {
    if (!state.formError) return '';
    const attr = state.formError.getAttribute(key);
    return attr || state.formError.getAttribute('data-default-error') || '';
  }

  function setSubmitEnabled(state, enabled) {
    if (!state.submitButton) return;
    if (enabled) {
      state.submitButton.removeAttribute('disabled');
      state.submitButton.removeAttribute('aria-disabled');
      return;
    }
    state.submitButton.setAttribute('disabled', 'disabled');
    state.submitButton.setAttribute('aria-disabled', 'true');
  }

  function setPriceVisible(state, visible) {
    if (!state.priceWrapper) return;
    state.priceWrapper.style.display = visible ? '' : 'none';
  }

  function syncGlobalState(state) {
    window.turnkeyInstallationState = {
      enabled: true,
      hasValidFee: state.isFeeReady,
      finalVariantId: state.finalVariantId,
      finalVariantSku: state.finalVariantSku,
      properties: {
        installation_zip: state.zipHidden ? state.zipHidden.value : '',
        installation_fee: state.feeHidden ? state.feeHidden.value : ''
      },
      notSelectVariantError: getErrorText(state, 'data-not-select-variant-error'),
      defaultError: getErrorText(state, 'data-default-error')
    };
  }

  function clearHiddenValues(state) {
    if (state.zipHidden) state.zipHidden.value = '';
    if (state.feeHidden) state.feeHidden.value = '';
  }

  function isSevenDayTarget(state, installProduct) {
    const product = String(installProduct || '').toUpperCase();
    if (product === 'SHP3' || product === 'SHP10') return true;
    const level1 = state.block.querySelector('[data-level-1-list-item] > [data-variant-item].active');
    const view = level1 ? level1.getAttribute('data-template-view') || '' : '';
    return view === 'shp3-install' || view === 'shp10-install';
  }

  function setSevenDayNote(state, show) {
    if (!state.sevenDayNote) return;
    state.sevenDayNote.hidden = !show;
  }

  function resetFeeState(state) {
    state.isFeeReady = false;
    clearHiddenValues(state);
    setSevenDayNote(state, false);
    setPriceVisible(state, false);
    setSubmitEnabled(state, false);
    state.block.classList.add('turnkey-installation--pending');
    state.block.classList.remove('turnkey-installation--ready');
    if (state.regularPrice) state.regularPrice.textContent = state.originalRegularPriceText;
    if (state.comparePrice) state.comparePrice.textContent = state.originalComparePriceText;
    if (state.totalSavings) state.totalSavings.textContent = state.originalTotalSavingsText;
    setError(state, '');
    syncGlobalState(state);
  }

  function isFinalSelectable(button) {
    const listItem = button.closest('.turnkey-installation__item');
    if (!listItem) return true;
    const childList = listItem.querySelector(':scope > .turnkey-installation__list');
    if (!childList) return true;

    const childItems = Array.from(childList.querySelectorAll(':scope > .turnkey-installation__item'));
    return childItems.length === 0;
  }

  function openChildList(button) {
    const listItem = button.closest('.turnkey-installation__item');
    if (!listItem) return null;
    const childList = listItem.querySelector(':scope > .turnkey-installation__list');
    if (!childList) return null;

    const siblingLists = listItem.parentElement
      ? listItem.parentElement.querySelectorAll(':scope > .turnkey-installation__item > .turnkey-installation__list')
      : [];

    siblingLists.forEach((list) => {
      if (list !== childList) {
        list.classList.remove('active');
      }
    });

    childList.classList.add('active');
    return childList;
  }

  function clearNestedActiveButtons(button) {
    const listItem = button.closest('.turnkey-installation__item');
    if (!listItem) return;
    const activeButtons = listItem.querySelectorAll('.turnkey-installation-item__btn.active');
    activeButtons.forEach((activeButton) => {
      activeButton.classList.remove('active');
    });
  }

  function clearSiblingActive(button) {
    const listItem = button.closest('.turnkey-installation__item');
    if (!listItem || !listItem.parentElement) return;
    const siblingItems = listItem.parentElement.querySelectorAll(':scope > .turnkey-installation__item');
    siblingItems.forEach((item) => {
      if (item !== listItem) {
        const activeButtons = item.querySelectorAll('.turnkey-installation-item__btn.active');
        activeButtons.forEach((activeButton) => activeButton.classList.remove('active'));
        const nestedLists = item.querySelectorAll('.turnkey-installation__list.active');
        nestedLists.forEach((list) => list.classList.remove('active'));
      }
    });
  }

  function markFinalSelection(state, button) {
    button.classList.add('active');
    state.finalVariantId = button.getAttribute('data-variant-id') || '';
    state.finalVariantSku = button.getAttribute('data-variant-sku') || '';

    const turnkey = document.querySelector(".product-container .turnkey-installation-block");
    if(turnkey.dataset.currentId && state.finalVariantId == turnkey.dataset.currentId){
      document.querySelector(".product-form__controls-group--submit .price-wrapper").classList.add("show");
      state.isFeeReady = true;
      setSubmitEnabled(state, true);
      state.block.classList.remove('turnkey-installation--pending');
      state.block.classList.add('turnkey-installation--ready');
    }else{
      document.querySelector(".product-form__controls-group--submit .price-wrapper").classList.remove("show");
      state.isFeeReady = false;
      setSubmitEnabled(state, false);
      state.block.classList.add('turnkey-installation--pending');
      state.block.classList.remove('turnkey-installation--ready');
      
    }

    syncGlobalState(state);
  }

  function redirectToInstallTemplate(button) {
    if (!button.hasAttribute('data-template-view')) return false;

    const targetView = button.getAttribute('data-template-view') || '';
    const url = new URL(window.location.href);
    const currentView = url.searchParams.get('view') || '';
    if (currentView === targetView) return false;

    if (targetView) {
      url.searchParams.set('view', targetView);
    } else {
      url.searchParams.delete('view');
    }

    const variantId = button.getAttribute('data-variant-id');
    if (variantId) url.searchParams.set('variant', variantId);

    window.location.assign(url.toString());
    return true;
  }

  function handleVariantClick(state, button) {
    if(button.getAttribute('data-url')){
      window.location.href = button.getAttribute('data-url');
      return;
    }
    if (redirectToInstallTemplate(button)) return;
    clearSiblingActive(button);
    clearNestedActiveButtons(button);
    button.classList.add('active');
    window.turnkeyInstallationStateObserver.disconnect();
    if (button.dataset.variantPrice && state.productPrice && window.turnkeyInstallationStateObserver) {
      window.turnkeyInstallationStateObserver.disconnect();
      state.productPrice.querySelector('.price-item--regular').textContent = "$"+ (button.dataset.variantPrice/100.0).toFixed(2);
    }
    
    if(button.dataset.variantImage){
      const thumbnails_image = document.querySelectorAll(".product-container .thumbnails-block_wrapper img")[0]
      const medias_image = document.querySelectorAll(".product-container .product-single__media-wrapper img")[0]
      if(thumbnails_image){
        thumbnails_image.src = button.dataset.variantImage
        thumbnails_image.srcset = button.dataset.variantImage
      }
      if(medias_image){
        medias_image.src = button.dataset.variantImage
        medias_image.srcset = button.dataset.variantImage
      }
      
    }
    openChildList(button);

    if (isFinalSelectable(button)) {
      const nextVariantId = button.getAttribute('data-variant-id') || '';
      const nextVariantSku = button.getAttribute('data-variant-sku') || '';
      const shouldReset =
        state.isFeeReady &&
        (state.finalVariantId !== nextVariantId || state.finalVariantSku !== nextVariantSku);
      
      if (shouldReset || !state.isFeeReady) {
        resetFeeState(state);
      }
      markFinalSelection(state, button);
      return;
    }

    if (state.finalVariantId || state.finalVariantSku || state.isFeeReady) {
      state.finalVariantId = '';
      state.finalVariantSku = '';
      resetFeeState(state);
    } else {
      syncGlobalState(state);
    }
  }

  function bindVariantEvents(state) {
    const buttons = state.block.querySelectorAll('[data-variant-item]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => handleVariantClick(state, button));
    });
    const init_button = document.querySelector(".turnkey-installation-item__btn.init-active");
    if(init_button){
      init_button.click();
    }
  }

  function canRequestFee(state) {
    return Boolean(state.finalVariantSku && state.finalVariantId);
  }

  async function requestFee(state) {
    if (state.isRequesting) return;

    const notSelectVariantError = getErrorText(state, 'data-not-select-variant-error');
    if (!canRequestFee(state)) {
      setError(state, notSelectVariantError);
      if (state.formSubmit) state.formSubmit.classList.remove('is-loading');
      return;
    }

    const zipCode = state.formInput ? state.formInput.value.trim() : '';
    if (!zipCode) {
      setError(state, getErrorText(state, 'data-installation-form-empty-error'));
      if (state.formSubmit) state.formSubmit.classList.remove('is-loading');
      return;
    }

    state.isRequesting = true;
    if (state.formSubmit) state.formSubmit.setAttribute('disabled', 'disabled');
    setError(state, '');
    setSevenDayNote(state, false);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-APPID': API_APP_ID
        },
        body: JSON.stringify({
          sku: state.finalVariantSku,
          zipCode
        })
      });

      const result = await response.json();
      if (!response.ok || !result || result.code !== '0') {
        const errorMessage =
          (result && result.message) || getErrorText(state, 'data-default-error');
        resetFeeState(state);
        setError(state, errorMessage);
        return;
      }

      const totalFee =
        result.data && result.data.totalFee !== undefined ? result.data.totalFee : '';
      const currency = result.data && result.data.currency ? result.data.currency : '';
      const installProduct = result.data && result.data.installProduct;
      const sevenDayInstallAvailable = result.data ? result.data.sevenDayInstallAvailable : true;
      const showSevenDayNote = isSevenDayTarget(state, installProduct) && sevenDayInstallAvailable === false;

      if (state.zipHidden) state.zipHidden.value = zipCode;
      if (state.feeHidden) state.feeHidden.value = toCurrencyLikeValue(totalFee);
      state.isFeeReady = true;
      if (state.regularPrice) {
        const feeText = toCurrencyLikeValue(totalFee);
        state.regularPrice.textContent = currency === 'USD' ? `$${feeText}` : feeText;
      }
      if (state.productPrice && window.turnkeyInstallationStateObserver) {
        window.turnkeyInstallationStateObserver.disconnect();
        const feeText = toCurrencyLikeValue(totalFee);
        state.productPrice.querySelector('.price-item--regular').textContent = currency === 'USD' ? `$${feeText}` : feeText;
      }
      if (state.comparePrice) state.comparePrice.textContent = '';
      if (state.totalSavings) state.totalSavings.textContent = '';

      setSevenDayNote(state, showSevenDayNote);
      setPriceVisible(state, true);
      setSubmitEnabled(state, true);
      state.block.classList.remove('turnkey-installation--pending');
      state.block.classList.add('turnkey-installation--ready');
      setError(state, '');
      syncGlobalState(state);
    } catch (error) {
      resetFeeState(state);
      setError(state, getErrorText(state, 'data-default-error'));
    } finally {
      state.isRequesting = false;
      if (state.formSubmit) {
        state.formSubmit.removeAttribute('disabled');
        state.formSubmit.classList.remove('is-loading');
      }
    }
  }

  function bindFeeEvents(state) {
    if (state.formSubmit) {
      state.formSubmit.addEventListener('click', () => {
        if (!state.isRequesting) state.formSubmit.classList.add('is-loading');
        requestFee(state);
      });
    }

    if (state.formInput) {
      state.formInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          requestFee(state);
        }
      });
    }
  }

  function initState(state) {
    setPriceVisible(state, false);
    clearHiddenValues(state);
    setError(state, '');
    setSubmitEnabled(state, false);
    syncGlobalState(state);
  }

  function initTurnkeyInstallationBlock() {
    const block = document.querySelector('.turnkey-installation-block');
    if (!block) {
      window.turnkeyInstallationState = {
        enabled: false
      };
      return;
    }

    const state = createState(block);
    initState(state);
    bindVariantEvents(state);
    bindFeeEvents(state);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTurnkeyInstallationBlock);
  } else {
    initTurnkeyInstallationBlock();
  }
})();
